import LinkBrokenIcon from '@atlaskit/icon/core/link-broken';
import * as React from 'react';

export function SvgLinkBroken() {
  return (
    <>
      <span className="lens-legacy-icon" />
      <LinkBrokenIcon label="" />
    </>
  );
}
